(function($) {

	'use strict';

	var init = function() {
    $('.news__filter__select').on('change', function() {
      $('.news__filter__form').submit();
		});
	};

	$(document).ready(function() {
		if($('body').hasClass('blog')) {
      init();
    }
	});

})(jQuery);
